import React, { createContext, useContext, useEffect, useState } from "react";

const STR = {
  fr: {
    "shipping.product_changed": "Les mesures du produit ont changé. Rechargez les produits et vérifiez-les à nouveau.",
    "shipping.profile_changed": "Enregistrez les emballages, puis rechargez cette page avant d’appliquer la règle.",
    "shipping.configuration_pending": "La livraison de ce panier doit encore être configurée par la boutique. Contactez-nous pour organiser votre commande.",
    "shipping.profile_incomplete": "Renseignez le carton prédéfini, son poids à vide, son calage mesuré et sa limite de poids dans Shipping.",
    "shipping.invalid_packing_rule": "Choisissez un emballage admis et une quantité vérifiée entre 1 et 100.",
    "shipping.profile_requires_easypost": "Les emballages prédéfinis exigent les tarifs EasyPost activés.",
    "shipping.invalid_margin": "Marge invalide : montant positif ou nul, deux décimales, maximum 100 % ou 1 000 USD.",
    "shipping.not_activated": "La livraison n’est pas encore disponible. Veuillez contacter la boutique.",
    "shipping.readiness_incomplete": "La configuration de livraison est incomplète.",
    "shipping.production_mode_required": "La configuration de production du transporteur est requise.",
    "shipping.approval_required": "La configuration de livraison doit être approuvée.",
    "shipping.verification_required": "Les mesures de livraison des produits doivent être vérifiées.",

    "selling.photoNotice": "La photo peut montrer le sac du fournisseur. Chaque quantité achetée correspond à une marmite, pas au sac entier.",
    "shipping.invalid_selling_unit": "Vérifiez l’unité de vente et la présentation client.",
    "selling.unit.marmite": "Marmite",
    "selling.sold.marmite": "Vendu par marmite",
    "selling.unit.bag": "Sac",
    "selling.sold.bag": "Vendu par sac",
    "selling.unit.bottle": "Bouteille",
    "selling.sold.bottle": "Vendu par bouteille",
    "selling.unit.box": "Boîte",
    "selling.sold.box": "Vendu par boîte",
    "selling.unit.can": "Conserve",
    "selling.sold.can": "Vendu par conserve",
    "selling.unit.pack": "Paquet",
    "selling.sold.pack": "Vendu par paquet",
    "selling.unit.unit": "Unité",
    "selling.sold.unit": "Vendu à l’unité",

    "shipping.fallback_unavailable": "Aucun tarif configuré ne couvre cette destination et ce poids. Veuillez nous contacter.",
    "shipping.address_required": "Saisissez l’adresse de livraison complète avant de calculer les frais.",
    "tracking.title": "Suivre ma commande",
    "tracking.number": "Numéro de commande",
    "tracking.email": "Courriel utilisé lors du paiement",
    "tracking.hint": "Indiquez votre numéro de commande et votre courriel. Si les informations correspondent, nous vous enverrons votre lien de suivi sécurisé. Aucun compte requis.",
    "tracking.submit": "Envoyer le lien de suivi",
    "tracking.checkEmail": "Si ces informations correspondent à une commande, un lien sera envoyé à son adresse courriel. Consultez votre boîte de réception et vos indésirables.",
    "tracking.rateLimited": "Trop de demandes. Réessayez dans 15 minutes.",
    "tracking.unavailable": "Le service est temporairement indisponible. Veuillez réessayer.",
    "tracking.refresh": "Actualiser la commande",
    "tracking.accessHelp": "Utilisez votre lien original ou demandez un lien de suivi ci-dessous. Aucun compte requis.",

    "sales.loading": "Chargement des ventes…",
    "sales.title": "Aperçu des ventes",
    "sales.period": "Période des ventes",
    "sales.7d": "7 jours",
    "sales.30d": "30 jours",
    "sales.12m": "12 mois",
    "sales.empty": "Aucune vente pour cette période.",
    "sales.revenue": "Chiffre d’affaires (USD)",
    "sales.order": "commande",
    "sales.orders": "commandes",
    "orders.emailNotSent": "Non envoyé",
    "orders.emailResend": "Renvoyer le courriel d’expédition",
    "orders.emailRefresh": "Actualiser le statut du courriel",
    "orders.emailUncertain": "L’envoi n’a pas été confirmé. Vous pouvez réessayer avec les informations d’expédition enregistrées.",
    "orders.emailConfirmUncertain": "Le courriel précédent a peut-être déjà été envoyé. Je comprends qu’un nouvel envoi pourrait créer un doublon.",
    "orders.email_in_progress": "Un envoi est déjà en cours. Patientez un instant, puis actualisez son statut.",
    "orders.email_confirm_uncertain": "Actualisez le statut du courriel et confirmez le risque de doublon avant de le renvoyer.",
    "orders.email_not_shipped": "Les courriels d’expédition ne peuvent être envoyés que pour une commande actuellement marquée Expédiée.",
    "orders.email_invalid_order": "Vérifiez le courriel du client et les informations de suivi enregistrées avant l’envoi.",
    "orders.email_retry_failed": "L’envoi du courriel n’a pas pu être confirmé. La commande et le suivi sont enregistrés. Actualisez son statut avant de réessayer.",
    "orders.title": "Commandes",
    "orders.all": "Toutes",
    "orders.new": "Nouvelle",
    "orders.preparing": "En préparation",
    "orders.ready_to_ship": "Prête à expédier",
    "orders.shipped": "Expédiée",
    "orders.delivered": "Livrée",
    "orders.cancelled": "Annulée",
    "orders.unknown": "Statut indisponible",
    "orders.refunded": "Déjà remboursée",
    "orders.start": "Commencer la préparation",
    "orders.ready": "Marquer prête à expédier",
    "orders.ship": "Expédier la commande",
    "orders.deliver": "Marquer comme livrée",
    "orders.confirmShipment": "Confirmer l’expédition",
    "orders.view": "Voir la commande",
    "orders.next": "Prochaine étape",
    "orders.customer": "Client",
    "orders.email": "Courriel",
    "orders.phone": "Téléphone",
    "orders.address": "Adresse de livraison",
    "orders.payment": "Paiement",
    "orders.status": "Commande",
    "orders.method": "Mode de livraison",
    "orders.standard": "Standard",
    "orders.express": "Express",
    "orders.carrier": "Transporteur",
    "orders.tracking": "Numéro de suivi",
    "orders.other": "Autre",
    "orders.track": "Suivre le colis",
    "orders.otherHint": "Contactez le transporteur avec cette référence de suivi.",
    "orders.trackingPending": "Les informations de suivi ne sont pas disponibles pour cette commande.",
    "orders.paid": "Payé",
    "orders.pending": "En attente",
    "orders.failed": "Échoué",
    "orders.paymentRefunded": "Remboursé",
    "orders.payment_required": "Le paiement doit être confirmé avant de préparer ou d’expédier cette commande.",
    "orders.more": "Autres actions",
    "orders.cancel": "Annuler la commande",
    "orders.cancelConfirm": "Annuler cette commande ? Cette action ne rembourse pas le paiement.",
    "orders.correct": "Corriger le statut",
    "orders.reason": "Motif de la correction",
    "orders.save": "Enregistrer la correction",
    "orders.close": "Fermer",
    "orders.back": "Retour",
    "orders.saving": "Enregistrement…",
    "orders.updated": "Commande mise à jour",
    "orders.search": "Rechercher un numéro, un client ou un courriel",
    "orders.searchLabel": "Rechercher des commandes",
    "orders.empty": "Aucune commande trouvée",
    "orders.loading": "Chargement des commandes…",
    "orders.loadError": "Impossible de charger les commandes. Veuillez réessayer.",
    "orders.retry": "Réessayer",
    "orders.updateError": "Enregistrement impossible. Rouvrez la commande pour vérifier son statut avant de réessayer.",
    "orders.detail": "Détails de la commande",
    "orders.items": "Produits",
    "orders.noItems": "Aucun produit enregistré",
    "orders.noAddress": "Aucune adresse enregistrée",
    "orders.progress": "Progression de la commande",
    "orders.confirmed": "Commande confirmée",
    "orders.placed": "Commande passée",
    "orders.paymentConfirmed": "Paiement confirmé",
    "orders.timeline": "Historique de la commande",
    "orders.current": "Étape actuelle",
    "orders.date": "Date de commande",
    "orders.legacyNote": "Seules les dates enregistrées sont affichées.",
    "orders.tracking_required": "Choisissez un transporteur et saisissez un numéro de suivi avec des lettres, des chiffres ou des tirets.",
    "orders.invalid_transition": "Cette action n’est pas disponible à cette étape.",
    "orders.order_changed": "Cette commande a été modifiée. Rouvrez-la avant de continuer.",
    "orders.shipment_already_saved": "Cette expédition est déjà enregistrée. Un nouvel envoi ne peut pas remplacer son suivi.",
    "orders.not_found": "Commande introuvable",
    "orders.emailState": "Courriel d’expédition",
    "orders.emailSent": "Envoyé",
    "orders.emailPending": "En cours ou en attente de traitement",
    "orders.emailFailed": "Non envoyé. Contactez le client à l’aide des détails de sa commande.",
    "orders.countHint": "Les totaux portent sur les 1 000 commandes les plus récentes.",
    "order.status.new": "Nouvelle",
    "order.status.preparing": "En préparation",
    "order.status.ready_to_ship": "Prête à expédier",
    "shipping.calculate": "Calculer la livraison",
    "shipping.promotion_unverified": "Impossible de vérifier la livraison gratuite pour ce code postal. Les tarifs payants sont affichés. Réessayez ou contactez-nous avant de payer.",
    "shipping.calculating": "Calcul de la livraison…",
    "shipping.enterZip": "Saisissez votre adresse de livraison complète, puis calculez les options disponibles.",
    "shipping.atCheckout": "Calculée lors du paiement",
    "shipping.pending": "Non calculée",
    "shipping.automatic": "Livraison",
    "shipping.invalid_grid": "La grille de livraison doit être vérifiée par la boutique.",
    "shipping.grid_product_review": "Ce produit nécessite une vérification par la boutique avant livraison.",
    "shipping.grid_destination": "Cette destination n’est pas encore desservie. Contactez la boutique.",
    "shipping.grid_limit": "Ce panier dépasse les limites de livraison prévues. Contactez la boutique pour un devis adapté.",
    "shipping.standard": "Livraison standard",
    "shipping.express": "Livraison express",
    "shipping.none": "Aucune livraison nécessaire",
    "shipping.estimated": "Livraison estimée :",
    "shipping.businessDays": "jours ouvrables",
    "shipping.unavailable": "Impossible de calculer les tarifs de livraison en direct. Veuillez réessayer.",
    "shipping.invalid_zip": "Entrez un code postal américain valide (12345 ou 12345-6789).",
    "shipping.invalid_destination": "Vérifiez votre État ou territoire américain et votre code postal. Ils doivent correspondre.",
    "shipping.service_unavailable": "Aucun service de livraison disponible pour cette adresse et ce colis. Vérifiez votre adresse ou contactez-nous.",
    "shipping.package_unavailable": "Cette commande nécessite un devis de livraison personnalisé. Contactez-nous.",
    "shipping.quote_expired": "Votre devis a changé ou a expiré. Recalculez la livraison avant le paiement.",
    "shipping.invalid_coupon": "Ce code promotionnel n’est plus valide pour votre panier. Retirez-le ou appliquez un autre code.",
    "shipping.fallbackNotice": "Les tarifs du transporteur sont indisponibles. Les tarifs configurés par la boutique sont affichés.",
    "shipping.servicesNotice": "Seuls les services disponibles sont affichés. Les délais de livraison ne sont pas garantis.",
    "shipping.beforeShipping": "Avant livraison et taxes",
    "shipping.country": "États-Unis / territoires américains",
    "shipping.invalid_settings": "Saisissez une origine et des dimensions de colis valides.",
    "shipping.invalid_product_shipping": "Saisissez des mesures de livraison valides pour le produit.",
    "shipping.missing_measurements": "Les mesures de livraison sont indisponibles. Contactez-nous.",

    "nav.home": "Accueil", "nav.shop": "Boutique",
    "nav.services": "Services", "nav.about": "À propos", "nav.contact": "Contact",
    "nav.search": "Rechercher des produits...", "nav.account": "Mon compte", "nav.wishlist": "Favoris",
    "nav.cart": "Panier", "nav.login": "Connexion", "nav.register": "S'inscrire", "nav.logout": "Déconnexion",
    "nav.dashboard": "Tableau de bord", "nav.admin": "Administration",
    "common.shopNow": "Magasiner maintenant", "common.viewAll": "Voir tout",
    "common.addToCart": "Ajouter au panier", "common.buyNow": "Acheter maintenant",
    "common.quickView": "Aperçu rapide", "common.outOfStock": "Rupture de stock",
    "common.inStock": "En stock", "common.sale": "Promo", "common.new": "Nouveau",
    "common.from": "À partir de", "common.loading": "Chargement...", "common.viewDetails": "Voir le produit",
    "common.related": "Produits similaires", "common.reviews": "Avis", "common.description": "Description",
    "common.ingredients": "Ingrédients", "common.origin": "Origine", "common.weight": "Poids/Taille",
    "common.quantity": "Quantité", "common.subtotal": "Sous-total", "common.total": "Total",
    "common.shipping": "Livraison", "common.discount": "Réduction", "common.tax": "Taxes",
    "common.free": "Gratuit", "common.continue": "Continuer", "common.save": "Enregistrer",
    "common.submit": "Envoyer", "common.remove": "Retirer", "common.email": "Email",
    "common.password": "Mot de passe", "common.name": "Nom", "common.phone": "Téléphone",
    "common.error": "Une erreur est survenue. Veuillez réessayer.",
    "common.retry": "Réessayer", "common.loadError": "Impossible de charger les données pour le moment.",
    "common.notFound": "Introuvable", "common.category": "Catégorie", "common.specifications": "Spécifications",
    "home.categories": "Magasinez par catégorie", "home.featured": "Produits Vedettes",
    "home.bestsellers": "Meilleures Ventes", "home.newArrivals": "Nouveautés",
    "home.offers": "Offres Spéciales", "home.pwodwi": "Pwodwi Lakay",
    "home.learnMore": "En savoir plus",
    "shop.title": "Boutique", "shop.filters": "Filtres", "shop.category": "Catégorie",
    "shop.all": "Toutes", "shop.sort": "Trier par", "shop.price": "Prix", "shop.rating": "Note",
    "shop.newest": "Nouveautés", "shop.noResults": "Aucun produit trouvé.", "shop.products": "produits",
    "cart.title": "Votre Panier", "cart.empty": "Votre panier est vide.",
    "cart.promo": "Code promo", "cart.apply": "Appliquer", "cart.checkout": "Passer à la caisse",
    "cart.estShipping": "Livraison estimée", "cart.freeShip": "Livraison gratuite dès",
    "checkout.title": "Paiement", "checkout.contact": "Coordonnées", "checkout.address": "Adresse de livraison",
    "checkout.method": "Méthode de livraison", "checkout.review": "Révision de la commande",
    "checkout.payment": "Paiement", "checkout.placeOrder": "Payer et commander",
    "checkout.usOnly": "Livraison uniquement aux États-Unis",
    "checkout.orderSummary": "Résumé de la commande", "checkout.showSummary": "Afficher le résumé",
    "checkout.hideSummary": "Masquer le résumé", "checkout.itemsCount": "article(s)",
    "checkout.firstName": "Prénom", "checkout.lastName": "Nom de famille",
    "checkout.addressLine1": "Adresse", "checkout.addressLine2": "Complément (optionnel)",
    "checkout.city": "Ville", "checkout.state": "État (US)", "checkout.zip": "Code postal",
    "checkout.country": "Pays", "checkout.phoneOptional": "Téléphone (optionnel)",
    "checkout.shippingMethod": "Méthode d'expédition", "checkout.billingAddress": "Adresse de facturation",
    "checkout.billingSame": "Identique à l'adresse de livraison",
    "checkout.billingDifferent": "Utiliser une adresse de facturation différente",
    "checkout.paymentMethod": "Mode de paiement",
    "checkout.card": "Carte de crédit ou débit", "checkout.cardDesc": "Visa, Mastercard, American Express, Discover",
    "checkout.paypal": "PayPal", "checkout.paypalDesc": "Payez avec votre compte PayPal",
    "checkout.secureCheckout": "Paiement sécurisé",
    "checkout.secureCheckoutDesc": "Vos informations de paiement sont chiffrées et traitées de façon sécurisée.",
    "checkout.continueToPayment": "Continuer vers le paiement",
    "checkout.continueToSecurePayment": "Continuer vers le paiement sécurisé",
    "checkout.stripeRedirectNote": "Vous serez redirigé vers Stripe pour finaliser votre paiement en toute sécurité.",
    "checkout.payAmount": "Payer {amount}",
    "checkout.preparingPayment": "Préparation du paiement sécurisé...",
    "checkout.paymentUnavailable": "Ce mode de paiement n'est pas encore disponible. Veuillez réessayer plus tard ou choisir une autre méthode.",
    "checkout.paymentInitError": "Impossible d'initialiser le paiement. Veuillez réessayer.",
    "checkout.processingPayment": "Traitement du paiement...",
    "checkout.paymentFailed": "Le paiement a échoué",
    "checkout.tryAgain": "Réessayer",
    "checkout.emptyCartError": "Votre panier est vide.",
    "checkout.invalidEmail": "Veuillez entrer une adresse email valide.",
    "checkout.requiredField": "Ce champ est requis.",
    "checkout.selectPaymentMethod": "Veuillez sélectionner un mode de paiement.",
    "checkout.orderNumber": "Numéro de commande", "checkout.amountPaid": "Montant payé",
    "checkout.paymentMethodLabel": "Mode de paiement utilisé",
    "checkout.customerEmail": "Email du client", "checkout.itemsPurchased": "Articles achetés",
    "checkout.orderConfirmed": "Commande confirmée !",
    "checkout.confirmationEmailNote": "Un e-mail de confirmation sera envoyé à {email}.",
    "checkout.paymentSuccessfulTitle": "PAIEMENT RÉUSSI",
    "checkout.thankYouOrder": "Merci pour votre commande, {name} !",
    "checkout.orderConfirmedDesc": "Votre commande est confirmée et sera préparée avec soin.",
    "checkout.kreyolaThanks": "Merci d'avoir choisi Kreyola Boutik et d'apporter un peu d'Haïti chez vous.",
    "checkout.orderDate": "Date de la commande",
    "checkout.paymentStatusLabel": "Statut du paiement",
    "checkout.shippingTo": "Expédition vers",
    "checkout.whatsNext": "Et maintenant ?",
    "checkout.stepConfirmed": "Commande confirmée",
    "checkout.stepPreparing": "Préparation de vos produits",
    "checkout.stepShips": "Votre commande est expédiée",
    "checkout.stepDelivered": "Livraison",
    "checkout.viewMyOrder": "Voir ma commande",
    "checkout.viewOrder": "Voir / Suivre ma commande",
    "checkout.viewMyOrders": "Voir mes commandes",
    "checkout.continueShopping": "Continuer mes achats",
    "checkout.confirmingPayment": "Confirmation de votre paiement...",
    "checkout.confirmingPaymentDesc": "Veuillez patienter pendant que nous confirmons votre paiement avec Stripe.",
    "checkout.stillConfirmingTitle": "Nous confirmons toujours votre paiement",
    "checkout.stillConfirmingDesc": "Votre paiement a peut-être été reçu, mais la confirmation prend plus de temps que prévu.",
    "checkout.checkAgain": "Vérifier à nouveau",
    "checkout.paymentUnsuccessfulTitle": "Paiement non abouti",
    "checkout.paymentUnsuccessfulDesc": "Votre paiement n'a pas pu être finalisé.",
    "checkout.returnToCart": "Retour au panier",
    "checkout.cartStillSaved": "Votre panier est toujours enregistré.",
    "checkout.paymentNotCompletedTitle": "Le paiement n'a pas été finalisé.",
    "checkout.cartKept": "Votre panier a été conservé.",
    "checkout.returnToCheckout": "Retour à la caisse",
    "checkout.orderStatusLabel": "Statut de la commande",
    "checkout.wantEasierAccess": "Vous voulez un accès plus simple à vos commandes ?",
    "checkout.createAccount": "Créer un compte",
    "checkout.signIn": "Se connecter",
    "checkout.orderNotFoundTitle": "Commande introuvable",
    "checkout.orderAccessDeniedDesc": "Cette commande n'existe pas ou vous n'y avez pas accès.",
    "checkout.signInToView": "Connectez-vous pour voir cette commande.",
    "checkout.loadingOrder": "Chargement de votre commande...",
    "checkout.itemsInOrder": "Produits",
    "auth.loginTitle": "Connexion", "auth.registerTitle": "Créer un compte",
    "auth.forgot": "Mot de passe oublié ?", "auth.noAccount": "Pas de compte ?",
    "auth.haveAccount": "Déjà un compte ?", "auth.resetTitle": "Réinitialiser le mot de passe",
    "auth.welcomeBack": "Content de vous revoir !", "auth.accountCreated": "Compte créé !",
    "auth.tagline": "Produits Haïtiens Authentiques, Livrés Partout aux États-Unis.",
    "footer.newsletter": "Restez Connecté à Lakay", "footer.subscribe": "S'abonner",
    "footer.emailPlaceholder": "Votre adresse email",
    "wishlist.added": "Ajouté aux favoris", "wishlist.removed": "Retiré des favoris",
    "order.status.pending": "En attente", "order.status.paid": "Payée", "order.status.processing": "En traitement",
    "order.status.shipped": "Expédiée", "order.status.delivered": "Livrée",
    "order.status.cancelled": "Annulée", "order.status.refunded": "Remboursée",
  },
  en: {
    "shipping.product_changed": "Product measurements changed. Reload the products and verify them again.",
    "shipping.profile_changed": "Save the packages, then reload this page before applying the rule.",
    "shipping.configuration_pending": "Shipping for this cart still needs to be configured by the store. Contact us to arrange your order.",
    "shipping.profile_incomplete": "Configure the predefined box, measured empty weight, padding and weight limit in Shipping.",
    "shipping.invalid_packing_rule": "Choose a supported package and a verified quantity from 1 to 100.",
    "shipping.profile_requires_easypost": "Predefined packages require enabled EasyPost rates.",
    "shipping.invalid_margin": "Invalid margin: nonnegative, two decimal places, maximum 100% or USD 1,000.",
    "shipping.not_activated": "Shipping is not available yet. Please contact the store.",
    "shipping.readiness_incomplete": "Shipping setup is incomplete.",
    "shipping.production_mode_required": "Production carrier configuration is required.",
    "shipping.approval_required": "Shipping configuration requires approval.",
    "shipping.verification_required": "Product shipping measurements require verification.",

    "selling.photoNotice": "The photo may show the supplier bag. Each quantity purchased is one marmite, not the full bag.",
    "shipping.invalid_selling_unit": "Check the selling unit and customer presentation.",
    "selling.unit.marmite": "Marmite",
    "selling.sold.marmite": "Sold by marmite",
    "selling.unit.bag": "Bag",
    "selling.sold.bag": "Sold by bag",
    "selling.unit.bottle": "Bottle",
    "selling.sold.bottle": "Sold by bottle",
    "selling.unit.box": "Box",
    "selling.sold.box": "Sold by box",
    "selling.unit.can": "Can",
    "selling.sold.can": "Sold by can",
    "selling.unit.pack": "Pack",
    "selling.sold.pack": "Sold by pack",
    "selling.unit.unit": "Unit",
    "selling.sold.unit": "Sold individually",

    "shipping.fallback_unavailable": "No configured shipping rate covers this destination and package weight. Please contact us.",
    "shipping.address_required": "Enter the complete shipping address before calculating shipping.",
    "tracking.title": "Track My Order",
    "tracking.number": "Order number",
    "tracking.email": "Email used at checkout",
    "tracking.hint": "Enter your order number and checkout email. We will email your secure tracking link if the details match. No account needed.",
    "tracking.submit": "Send tracking link",
    "tracking.checkEmail": "If these details match an order, a tracking link will be sent to its email address. Please check your inbox and spam folder.",
    "tracking.rateLimited": "Too many requests. Please try again in 15 minutes.",
    "tracking.unavailable": "Tracking recovery is temporarily unavailable. Please try again.",
    "tracking.refresh": "Refresh order",
    "tracking.accessHelp": "Use your original order link or request a tracking link below. No account is required.",

    "sales.loading": "Loading sales…",
    "sales.title": "Sales Overview",
    "sales.period": "Sales period",
    "sales.7d": "7 Days",
    "sales.30d": "30 Days",
    "sales.12m": "12 Months",
    "sales.empty": "No sales data for this period.",
    "sales.revenue": "Revenue (USD)",
    "sales.order": "order",
    "sales.orders": "orders",
    "orders.emailNotSent": "Not sent",
    "orders.emailResend": "Resend shipment email",
    "orders.emailRefresh": "Refresh email status",
    "orders.emailUncertain": "Sending has not been confirmed. You can retry safely using the saved shipment details.",
    "orders.emailConfirmUncertain": "The earlier email may already have been sent. I understand that resending could send another copy.",
    "orders.email_in_progress": "An email attempt is already in progress. Wait a moment, then refresh its status.",
    "orders.email_confirm_uncertain": "Refresh the email status and confirm the possible duplicate before resending.",
    "orders.email_not_shipped": "Shipment emails can only be sent for an order currently marked Shipped.",
    "orders.email_invalid_order": "Check the saved customer email and tracking details before sending.",
    "orders.email_retry_failed": "The email could not be confirmed. The order and tracking are saved. Refresh its email status before trying again.",
    "orders.title": "Orders",
    "orders.all": "All",
    "orders.new": "New",
    "orders.preparing": "Preparing",
    "orders.ready_to_ship": "Ready to Ship",
    "orders.shipped": "Shipped",
    "orders.delivered": "Delivered",
    "orders.cancelled": "Cancelled",
    "orders.unknown": "Status unavailable",
    "orders.refunded": "Previously refunded",
    "orders.start": "Start Preparing",
    "orders.ready": "Mark Ready to Ship",
    "orders.ship": "Ship Order",
    "orders.deliver": "Mark Delivered",
    "orders.confirmShipment": "Confirm Shipment",
    "orders.view": "View Order",
    "orders.next": "Next action",
    "orders.customer": "Customer",
    "orders.email": "Email",
    "orders.phone": "Phone",
    "orders.address": "Shipping address",
    "orders.payment": "Payment",
    "orders.status": "Order",
    "orders.method": "Shipping method",
    "orders.standard": "Standard",
    "orders.express": "Express",
    "orders.carrier": "Carrier",
    "orders.tracking": "Tracking number",
    "orders.other": "Other",
    "orders.track": "Track Package",
    "orders.otherHint": "Contact the carrier with this tracking reference.",
    "orders.trackingPending": "Tracking information is not available for this order.",
    "orders.paid": "Paid",
    "orders.pending": "Pending",
    "orders.failed": "Failed",
    "orders.paymentRefunded": "Refunded",
    "orders.payment_required": "Payment must be confirmed before preparing or shipping this order.",
    "orders.more": "More actions",
    "orders.cancel": "Cancel order",
    "orders.cancelConfirm": "Cancel this order? This does not issue a payment refund.",
    "orders.correct": "Correct status",
    "orders.reason": "Reason for correction",
    "orders.save": "Save correction",
    "orders.close": "Close",
    "orders.back": "Back",
    "orders.saving": "Saving…",
    "orders.updated": "Order updated",
    "orders.search": "Search order number, customer or email",
    "orders.searchLabel": "Search orders",
    "orders.empty": "No orders found",
    "orders.loading": "Loading orders…",
    "orders.loadError": "Could not load orders. Please try again.",
    "orders.retry": "Retry",
    "orders.updateError": "Could not save. Reopen the order to check its current status before trying again.",
    "orders.detail": "Order details",
    "orders.items": "Products",
    "orders.noItems": "No products recorded",
    "orders.noAddress": "No address recorded",
    "orders.progress": "Order progress",
    "orders.confirmed": "Order confirmed",
    "orders.placed": "Order placed",
    "orders.paymentConfirmed": "Payment confirmed",
    "orders.timeline": "Order timeline",
    "orders.current": "Current stage",
    "orders.date": "Order date",
    "orders.legacyNote": "Only recorded dates are shown.",
    "orders.tracking_required": "Choose a carrier and enter a tracking number using letters, numbers or hyphens.",
    "orders.invalid_transition": "This action is not available for the current order stage.",
    "orders.order_changed": "Another update changed this order. Reopen it before continuing.",
    "orders.shipment_already_saved": "This shipment is already saved. Tracking cannot be replaced by submitting it again.",
    "orders.not_found": "Order not found",
    "orders.emailState": "Shipment email",
    "orders.emailSent": "Sent",
    "orders.emailPending": "Sending or awaiting processing",
    "orders.emailFailed": "Not sent. Contact the customer using their order details.",
    "orders.countHint": "Counts reflect the most recent 1,000 orders.",
    "order.status.new": "New",
    "order.status.preparing": "Preparing",
    "order.status.ready_to_ship": "Ready to Ship",
    "shipping.calculate": "Calculate shipping",
    "shipping.promotion_unverified": "We couldn’t verify free shipping for this ZIP code. Paid rates are shown. Retry or contact us before paying.",
    "shipping.calculating": "Calculating shipping…",
    "shipping.enterZip": "Enter your full shipping address, then calculate available shipping options.",
    "shipping.atCheckout": "Calculated at checkout",
    "shipping.pending": "Not calculated",
    "shipping.automatic": "Delivery",
    "shipping.invalid_grid": "The store needs to review its delivery price grid.",
    "shipping.grid_product_review": "This product requires a store review before delivery.",
    "shipping.grid_destination": "This destination is not currently served. Please contact the store.",
    "shipping.grid_limit": "This cart exceeds the configured delivery limits. Contact the store for a suitable quote.",
    "shipping.standard": "Standard Shipping",
    "shipping.express": "Express Shipping",
    "shipping.none": "No shipping required",
    "shipping.estimated": "Estimated delivery:",
    "shipping.businessDays": "business days",
    "shipping.unavailable": "We couldn't calculate live shipping rates. Please try again.",
    "shipping.invalid_zip": "Enter a valid US ZIP code (12345 or 12345-6789).",
    "shipping.invalid_destination": "Check your US state or territory and ZIP code. They must match.",
    "shipping.service_unavailable": "No shipping service is available for this address and package. Please check your address or contact us.",
    "shipping.package_unavailable": "This order needs a custom shipping quote. Please contact us.",
    "shipping.quote_expired": "Your shipping quote changed or expired. Calculate shipping again before payment.",
    "shipping.invalid_coupon": "This coupon is no longer valid for your cart. Remove it or apply another coupon.",
    "shipping.fallbackNotice": "Live carrier rates are unavailable. Store-configured shipping rates are shown.",
    "shipping.servicesNotice": "Only available services are shown. Delivery estimates are not guaranteed.",
    "shipping.beforeShipping": "Before shipping and tax",
    "shipping.country": "United States / US territories",
    "shipping.invalid_settings": "Enter a valid origin and package measurements.",
    "shipping.invalid_product_shipping": "Enter valid product shipping measurements.",
    "shipping.missing_measurements": "Shipping measurements are unavailable. Please contact us.",

    "nav.home": "Home", "nav.shop": "Shop",
    "nav.services": "Services", "nav.about": "About Us", "nav.contact": "Contact",
    "nav.search": "Search products...", "nav.account": "My Account", "nav.wishlist": "Wishlist",
    "nav.cart": "Cart", "nav.login": "Login", "nav.register": "Sign Up", "nav.logout": "Logout",
    "nav.dashboard": "Dashboard", "nav.admin": "Admin",
    "common.shopNow": "Shop Now", "common.viewAll": "View All",
    "common.addToCart": "Add to Cart", "common.buyNow": "Buy Now",
    "common.quickView": "Quick View", "common.outOfStock": "Out of Stock",
    "common.inStock": "In Stock", "common.sale": "Sale", "common.new": "New",
    "common.from": "From", "common.loading": "Loading...", "common.viewDetails": "View Product",
    "common.related": "Related Products", "common.reviews": "Reviews", "common.description": "Description",
    "common.ingredients": "Ingredients", "common.origin": "Origin", "common.weight": "Weight/Size",
    "common.quantity": "Quantity", "common.subtotal": "Subtotal", "common.total": "Total",
    "common.shipping": "Shipping", "common.discount": "Discount", "common.tax": "Tax",
    "common.free": "Free", "common.continue": "Continue", "common.save": "Save",
    "common.submit": "Submit", "common.remove": "Remove", "common.email": "Email",
    "common.password": "Password", "common.name": "Name", "common.phone": "Phone",
    "common.error": "Something went wrong. Please try again.",
    "common.retry": "Retry", "common.loadError": "Couldn't load data right now.",
    "common.notFound": "Not found", "common.category": "Category", "common.specifications": "Specifications",
    "home.categories": "Shop by Category", "home.featured": "Featured Products",
    "home.bestsellers": "Best Sellers", "home.newArrivals": "New Arrivals",
    "home.offers": "Special Offers", "home.pwodwi": "Pwodwi Lakay",
    "home.learnMore": "Learn More",
    "shop.title": "Shop", "shop.filters": "Filters", "shop.category": "Category",
    "shop.all": "All", "shop.sort": "Sort by", "shop.price": "Price", "shop.rating": "Rating",
    "shop.newest": "Newest", "shop.noResults": "No products found.", "shop.products": "products",
    "cart.title": "Your Cart", "cart.empty": "Your cart is empty.",
    "cart.promo": "Promo code", "cart.apply": "Apply", "cart.checkout": "Proceed to Checkout",
    "cart.estShipping": "Estimated shipping", "cart.freeShip": "Free shipping over",
    "checkout.title": "Checkout", "checkout.contact": "Contact Information", "checkout.address": "Shipping Address",
    "checkout.method": "Delivery Method", "checkout.review": "Order Review",
    "checkout.payment": "Payment", "checkout.placeOrder": "Pay & Place Order",
    "checkout.usOnly": "Delivery within the United States only",
    "checkout.orderSummary": "Order Summary", "checkout.showSummary": "Show order summary",
    "checkout.hideSummary": "Hide order summary", "checkout.itemsCount": "item(s)",
    "checkout.firstName": "First name", "checkout.lastName": "Last name",
    "checkout.addressLine1": "Address", "checkout.addressLine2": "Apt, suite (optional)",
    "checkout.city": "City", "checkout.state": "State (US)", "checkout.zip": "ZIP code",
    "checkout.country": "Country", "checkout.phoneOptional": "Phone (optional)",
    "checkout.shippingMethod": "Shipping Method", "checkout.billingAddress": "Billing Address",
    "checkout.billingSame": "Same as shipping address",
    "checkout.billingDifferent": "Use a different billing address",
    "checkout.paymentMethod": "Payment Method",
    "checkout.card": "Credit or Debit Card", "checkout.cardDesc": "Visa, Mastercard, American Express, Discover",
    "checkout.paypal": "PayPal", "checkout.paypalDesc": "Pay with your PayPal account",
    "checkout.secureCheckout": "Secure checkout",
    "checkout.secureCheckoutDesc": "Your payment information is encrypted and securely processed.",
    "checkout.continueToPayment": "Continue to Payment",
    "checkout.continueToSecurePayment": "Continue to Secure Payment",
    "checkout.stripeRedirectNote": "You'll be redirected to Stripe to complete your payment securely.",
    "checkout.payAmount": "Pay {amount}",
    "checkout.preparingPayment": "Preparing secure payment...",
    "checkout.paymentUnavailable": "This payment method isn't available yet. Please try again later or choose another method.",
    "checkout.paymentInitError": "We couldn't start your payment. Please try again.",
    "checkout.processingPayment": "Processing your payment...",
    "checkout.paymentFailed": "Payment failed",
    "checkout.tryAgain": "Try again",
    "checkout.emptyCartError": "Your cart is empty.",
    "checkout.invalidEmail": "Please enter a valid email address.",
    "checkout.requiredField": "This field is required.",
    "checkout.selectPaymentMethod": "Please select a payment method.",
    "checkout.orderNumber": "Order number", "checkout.amountPaid": "Amount paid",
    "checkout.paymentMethodLabel": "Payment method used",
    "checkout.customerEmail": "Customer email", "checkout.itemsPurchased": "Items purchased",
    "checkout.orderConfirmed": "Order confirmed!",
    "checkout.confirmationEmailNote": "A confirmation email will be sent to {email}.",
    "checkout.paymentSuccessfulTitle": "PAYMENT SUCCESSFUL",
    "checkout.thankYouOrder": "Thank you for your order, {name}!",
    "checkout.orderConfirmedDesc": "Your order has been confirmed and is being prepared with care.",
    "checkout.kreyolaThanks": "Thank you for choosing Kreyola Boutik and bringing a little taste of Haiti home.",
    "checkout.orderDate": "Order date",
    "checkout.paymentStatusLabel": "Payment status",
    "checkout.shippingTo": "Shipping to",
    "checkout.whatsNext": "What happens next?",
    "checkout.stepConfirmed": "Order confirmed",
    "checkout.stepPreparing": "Preparing your products",
    "checkout.stepShips": "Order ships",
    "checkout.stepDelivered": "Delivery",
    "checkout.viewMyOrder": "View My Order",
    "checkout.viewOrder": "View / Track My Order",
    "checkout.viewMyOrders": "View My Orders",
    "checkout.continueShopping": "Continue Shopping",
    "checkout.confirmingPayment": "Confirming your payment...",
    "checkout.confirmingPaymentDesc": "Please wait while we confirm your payment with Stripe.",
    "checkout.stillConfirmingTitle": "We're still confirming your payment",
    "checkout.stillConfirmingDesc": "Your payment may have been received, but confirmation is taking longer than expected.",
    "checkout.checkAgain": "Check Again",
    "checkout.paymentUnsuccessfulTitle": "Payment unsuccessful",
    "checkout.paymentUnsuccessfulDesc": "Your payment could not be completed.",
    "checkout.returnToCart": "Return to Cart",
    "checkout.cartStillSaved": "Your cart is still saved.",
    "checkout.paymentNotCompletedTitle": "Payment was not completed.",
    "checkout.cartKept": "Your cart has been kept.",
    "checkout.returnToCheckout": "Return to Checkout",
    "checkout.orderStatusLabel": "Order status",
    "checkout.wantEasierAccess": "Want easier access to your orders?",
    "checkout.createAccount": "Create Account",
    "checkout.signIn": "Sign In",
    "checkout.orderNotFoundTitle": "Order not found",
    "checkout.orderAccessDeniedDesc": "This order doesn't exist, or you don't have access to it.",
    "checkout.signInToView": "Sign in to view this order.",
    "checkout.loadingOrder": "Loading your order...",
    "checkout.itemsInOrder": "Items",
    "auth.loginTitle": "Login", "auth.registerTitle": "Create Account",
    "auth.forgot": "Forgot password?", "auth.noAccount": "No account?",
    "auth.haveAccount": "Already have an account?", "auth.resetTitle": "Reset Password",
    "auth.welcomeBack": "Welcome back!", "auth.accountCreated": "Account created!",
    "auth.tagline": "Authentic Haitian Products, Delivered Across the United States.",
    "footer.newsletter": "Stay Connected to Lakay", "footer.subscribe": "Subscribe",
    "footer.emailPlaceholder": "Your email address",
    "wishlist.added": "Added to wishlist", "wishlist.removed": "Removed from wishlist",
    "order.status.pending": "Pending", "order.status.paid": "Paid", "order.status.processing": "Processing",
    "order.status.shipped": "Shipped", "order.status.delivered": "Delivered",
    "order.status.cancelled": "Cancelled", "order.status.refunded": "Refunded",
  },
};

const LangContext = createContext(null);

export function translate(key, lang = "en") {
  return STR[lang]?.[key] || STR.en[key] || key;
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kb_lang") || "fr");
  useEffect(() => localStorage.setItem("kb_lang", lang), [lang]);
  const t = (key) => translate(key, lang);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}

// Localized field getter: L(item, "name") -> item.name_fr / item.name_en
export function useL() {
  const { lang } = useLang();
  return (item, key) => (item ? item[`${key}_${lang}`] ?? item[`${key}_en`] ?? "" : "");
}
